<template>
    <button ref="scrollButton" class="scrollButton bg-primary" @click="scrollToTop">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32"><g color="green"><path fill="none" d="M0 0h24v24H0z"/><path fill="white" d="M3 3h18v2H3V3zm5 8v10H6V11H3l4-4 4 4H8zm10 0v10h-2V11h-3l4-4 4 4h-3z"/></g></svg>
    </button>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue'

const scrollButton = ref();

const userScroll = () => {
    if (window.scrollY > 0) {
        scrollButton.value.classList.add("showButton");
        // console.log('scrolled');
    } else {
        scrollButton.value.classList.remove("showButton");
        // console.log('top');
    }
};

onMounted(() => {
    window.addEventListener("scroll", userScroll);
})

onBeforeMount(() => {
    window.removeEventListener("scroll", userScroll);
})

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

</script>

<style scoped>
.scrollButton {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    border: none;
    outline: none;
    background-color: #555;
    cursor: pointer;
    padding: 15px;
    border-radius: 10px;
    font-size: 18px;
    opacity: 0.7;
}

.showButton {
    display: block;
}
</style>